import { render, staticRenderFns } from "./Gestures.vue?vue&type=template&id=e4b0f258&scoped=true"
import script from "./Gestures.vue?vue&type=script&lang=js"
export * from "./Gestures.vue?vue&type=script&lang=js"
import style0 from "./Gestures.vue?vue&type=style&index=0&id=e4b0f258&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b0f258",
  null
  
)

export default component.exports